import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import './Logo.css'

var Nav = Backbone.View.extend({
    el: '.Logo',

    initialize () {
        _.bindAll(this, 'activate', 'deactivate')

        app.vent.on('logo.activate', this.activate)
    },

    activate (options) {
        $.Velocity.hook(this.$el, 'opacity', '0')

        this.$el[0].style.display = 'block'

        return $.Velocity.animate(this.$el, {
            opacity: [1, 'linear']
        }, _.extend({duration: 500}, options))
    },

    deactivate (options) {
        $.Velocity.hook(this.$el, 'opacity', '1')

        return $.Velocity.animate(this.$el, {
            opacity: [0, 'linear']
        }, _.extend({duration: 500}, options))
    }
})

export default Nav


// WEBPACK FOOTER //
// ./assets/app/front/components/Logo/Logo.js